import React from "react";
import BottomButton from "./BottomButton";
import { whiteBottomButtonStyles as styles } from "./styles";

interface BottomButtonProps {
  onPress: () => void;
  buttonText: string;
}

const WhiteBottomButton: React.FC<BottomButtonProps> = (
  props: BottomButtonProps,
) => {
  return <BottomButton {...props} styles={styles} />;
};

export default WhiteBottomButton;
